import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { RaskCommonModule } from "../../common/rask-common.module";
import { TransportModule } from "../transport/transport.module";
import { MatningsomfattningComponent } from "./virkesorder-preview/tool-tip/matningsomfattning/matningsomfattning.component";
import { VirkesorderService } from "./virkesorder.service";
@NgModule({
    imports: [
        RaskCommonModule,
        TransportModule,
        FormsModule,
        ReactiveFormsModule,
        AgGridModule,
        MatningsomfattningComponent
    ],
    providers: [VirkesorderService]
})
export class VirkesorderModule { }
